import React from 'react';
import Templates from './templates/page_type';
import CustomStylesMixin from './templates/custom_styles_mixin';

import createReactClass from 'create-react-class';
export default createReactClass({
  displayName: 'Preview',

  mixins: [CustomStylesMixin],

  componentDidMount: function() {
    this.has_status_page_value = this.props.has_status_page;
    this.setPreviewHeight();
    $(window).on('resize.setPreviewHeight', this.setPreviewHeight);
  },

  componentWillUnmount: function() {
    $(window).off('resize.setPreviewHeight');
  },

  componentDidUpdate: function() {
    if (this.has_status_page_value !== this.props.has_status_page) {
      $(this.refs.errorPageWrapper).trigger('resize');
    }
  },

  setPreviewHeight: function() {
    var $header = $('.bep-customize-header'),
      remainingHeight = window.innerHeight - $header.outerHeight(),
      optionSetHeight = $('.option-set')
        .filter(':visible')
        .outerHeight();

    var element = this.refs.errorPageWrapper;
    $(element)
      .css('height', Math.max(remainingHeight, optionSetHeight) + 'px')
      .trigger('resize');
  },

  templateByName: function(template, page_type) {
    var Template = Templates[template];
    var FourOhFour = Template.FourOhFour;
    var FiveOhThree = Template.FiveOhThree;
    var Maintenance = Template.Maintenance;
    switch (page_type) {
      case '404':
        return <FourOhFour {...this.props} />;
      case '503':
        return <FiveOhThree {...this.props} />;
      case 'maintenance':
        return <Maintenance {...this.props} />;
      default:
        new Error('Unknown template requested in preview_component.jsx');
    }
  },

  render: function() {
    var classes = ['preview', 'error-page-wrapper', this.props.template];

    return (
      <div
        className={classes.join(' ')}
        ref="errorPageWrapper"
        style={this.background()}
      >
        {this.templateByName(this.props.template, this.props.page_type)}
      </div>
    );
  },
});
